module.exports = __webpack_public_path__ + "img/LV2.a458e207.webp";